import home from './home/routes';
import detail from '../beautytechforumvirtual/detail/routes';

export default [home, detail];
